import React from 'react'
import PropTypes from 'prop-types'

import { Header, Modal } from 'semantic-ui-react'

import { compose } from 'recompose'

import Container from './ConfirmationModalContainer'
import Enhancer from './ConfirmationModalEnhancer'

import Button from 'Components/StandardButton'

import icons from 'Global/icons'

const ConfirmationModal = ({ handleAccept, handleClose, message }) => (
  <Modal onClose={handleClose} open={true} size="small" basic>
    <Header icon={icons['question']} content="Are you sure?" />

    <Modal.Content>
      <p>{message}</p>
    </Modal.Content>

    <Modal.Actions>
      <Button color="red" content="No" icon={icons['no']} onClick={handleClose} basic inverted />

      <Button color="green" content="Yes" icon={icons['yes']} onClick={handleAccept} basic inverted />
    </Modal.Actions>
  </Modal>
)

ConfirmationModal.propTypes = {
  handleAccept: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
)

export default composed(ConfirmationModal)
